var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M36.763 26.237H11.237a2.237 2.237 0 110-4.474h25.526a2.237 2.237 0 110 4.474z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PC9kZWZzPjxwYXRoIGZpbGw9IiM4Njg2ODYiIGQ9Ik0zNi43NjMsMjYuMjM3SDExLjIzN2EyLjIzNywyLjIzNywwLDEsMSwwLTQuNDc0SDM2Ljc2M0EyLjIzNywyLjIzNywwLDEsMSwzNi43NjMsMjYuMjM3WiIvPjwvc3ZnPg==";
export { SvgSubtract as ReactComponent };